export class MaintenanceRoutineImportModel {
    counter: number = 0;
    companyId: number = 0;
    articleCode: number = 0;
    maintenanceRoutineState: boolean = false;
    componentCode: number = 0;
    componentName: string = '';
    elementCode: number = 0;
    elementName: string = '';
    activityCode: number = 0;
    swEachUse: boolean = false;
    swMaintenancePlan1: boolean = false;
    swMaintenancePlan2: boolean = false;
    swMaintenancePlan3: boolean = false;
    swMaintenancePlan4: boolean = false;
    swMaintenancePlan5: boolean = false;
    swMaintenancePlan6: boolean = false;
    swMaintenancePlan7: boolean = false;

    constructor(counter: number,
        companyId: number,
        articleCode: number,
        maintenanceRoutineState: boolean,
        componentCode: number,
        componentName: string,
        elementCode: number,
        elementName: string,
        activityCode: number,
        swEachUse: boolean,
        swMaintenancePlan1: boolean,
        swMaintenancePlan2: boolean,
        swMaintenancePlan3: boolean,
        swMaintenancePlan4: boolean,
        swMaintenancePlan5: boolean,
        swMaintenancePlan6: boolean,
        swMaintenancePlan7: boolean,
    ) {
        this.counter = counter;
        this.companyId = companyId;
        this.articleCode = articleCode;
        this.maintenanceRoutineState = maintenanceRoutineState;
        this.componentCode = componentCode;
        this.componentName = componentName;
        this.elementCode = elementCode;
        this.elementName = elementName;
        this.activityCode = activityCode;
        this.swEachUse = swEachUse;
        this.swMaintenancePlan1 = swMaintenancePlan1;
        this.swMaintenancePlan2 = swMaintenancePlan2;
        this.swMaintenancePlan3 = swMaintenancePlan3;
        this.swMaintenancePlan4 = swMaintenancePlan4;
        this.swMaintenancePlan5 = swMaintenancePlan5;
        this.swMaintenancePlan6 = swMaintenancePlan6;
        this.swMaintenancePlan7 = swMaintenancePlan7;
    }
}